<!-- Page title component starts -->
<div *ngIf="aemData" ngclass="page-title">
  <div class="page-title">
    <div class="container">
      <h2 class="m-t-xl m-b-xl">{{ aemData?.chooseLineToEdit }}</h2>
    </div>
  </div>
  <div tmoTitleHeaderSpacing></div>
  <ng-container *ngIf="nonEditedLines?.length">
    <h3 class="m-t-xl" id="lineedit">{{ aemData?.linesYouCanEdit }}</h3>
    <div class="row" role="radiogroup" aria-labelledby="lineedit">
      <div *ngFor="let nonEditedLine of nonEditedLines; let ind = index" class="m-t-md col-12">
        <tmo-radio-button
          [values]="nonEditedLine?.lineOfServiceId"
          name="selectline"
          [selectedValue]="selectedOption"
          (onSelect)="onSelect(nonEditedLine?.lineOfServiceId)"
          [id]="'tmo-radio-button-selectline_' + ind"
        >
          <p *ngIf="nonEditedLine?.lineNickname">
            {{ nonEditedLine.lineNickname }}, {{ nonEditedLine.msisdn | phone }}
          </p>
          <p *ngIf="!nonEditedLine?.lineNickname">{{ nonEditedLine.msisdn | phone }}</p>
        </tmo-radio-button>
        <p
          class="small m-t-xs alert-text"
          *ngIf="selectedOption === nonEditedLine?.lineOfServiceId && pendingOrdersAvailable"
        >
          {{ aemData?.conflictingPendingOrder }}
        </p>
      </div>
    </div>
    <p class="m-t-lg">{{ aemData?.changedLinesEffectiveDate }}</p>
  </ng-container>
  <ng-container *ngIf="pendingOrdersAvailable">
    <hr class="divider m-t-xl" />
    <h3 class="m-t-xl">{{ conflictOrderHeader }}</h3>
    <p class="m-t-lg lead bold">{{ aemData?.selectOrderMessage }}</p>
    <div class="row" *ngFor="let order of linePendingOrdersModel?.ordersByType">
      <div class="col-12">
        <p class="lead bold m-t-md">{{ order?.label }} ({{ order?.value?.length }})</p>
      </div>
      <div class="col-12" *ngFor="let orderType of order?.value">
        <p class="m-t-sm">
          <a
            aria-label="Clickable Action"
            id="{{ orderType?.orderId }}"
            href="javascript:void(0);"
            (click)="goToOrderSummary(orderType?.orderId)"
          >
            {{ aemData?.order }} # {{ orderType?.orderId }}
          </a>
        </p>
      </div>
    </div>
  </ng-container>
  <hr class="divider m-t-xl" *ngIf="nonEditedLines?.length && editedLinesCheck" />
  <div *ngIf="editedLinesCheck">
    <h3 class="m-t-xl">{{ aemData?.linesEditedAlready }}</h3>
    <p class="m-t-lg bold">{{ aemData?.cancelChangesInCart }}</p>
    <ng-container *ngFor="let editedLine of editedLines; let ind = index">
      <p class="m-t-sm">{{ editedLine.msisdn | phone }}</p>
    </ng-container>
  </div>
  <div class="row">
    <div class="col-12 buttons-container buttons-3 button-spacing">
      <div class="button-box">
        <button
          class="btn btn-secondary btn-small"
          [attr.aria-label]="aemData?.cancel"
          (click)="cancelOrder()"
          id="btn-default-71"
        >
          {{ aemData?.cancel }}
        </button>
      </div>
      <div class="button-box">
        <button
          class="btn btn-secondary btn-small"
          [disabled]="!editedLinesCheck"
          [attr.aria-label]="aemData?.setOrderDate"
          (click)="onSetOrderContinue()"
          id="btn-default-72"
        >
          {{ aemData?.setOrderDate }}
        </button>
      </div>
      <div class="button-box">
        <button
          class="btn btn-primary btn-small"
          [disabled]="!nonEditedLines?.length || pendingOrdersAvailable"
          [attr.aria-label]="aemData?.continue"
          (click)="onContinueClick()"
          id="btn-default-73"
        >
          {{ aemData?.continue }}
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 m-b-xxl">
      <p class="legal">{{ aemData?.legalText }}</p>
    </div>
  </div>
</div>
<tmo-static-modal
  *ngIf="cancelOrderModalData"
  [modal]="cancelOrderModalData"
  (onSelect)="handleClickEvent()"
  (onClose)="setFocus()"
></tmo-static-modal>
<tmo-spinner [setDelay]="dataLoaded && aemData && hideSpinner"></tmo-spinner>
